'use client';

import { useWebView } from '../../hooks/useWebView';
import { MedalliaLoaderV2 } from './medallia-loader-v2';

export const MedalliaV2 = () => {
    const isWebView = useWebView();

    if (isWebView) return null;

    return <MedalliaLoaderV2 />;
};
